import { LegalPage } from "./LegalPage";
import { LEGAL } from "@/lib/legal";

export default function Privacidad() {
  return (
    <LegalPage title="Política de privacidad">
      <p>
        En <strong>{LEGAL.brand}</strong> nos tomamos en serio tu privacidad. Esta política explica qué datos recogemos cuando usas nuestra aplicación en <a href={`https://${LEGAL.domain}`}>{LEGAL.domain}</a>, para qué los usamos, con quién los compartimos y qué derechos tienes sobre ellos.
      </p>

      <h2>1. Quién es el responsable de tus datos</h2>
      <p>
        El responsable del tratamiento de los datos es <strong>{LEGAL.legalName}</strong>, con domicilio fiscal en {LEGAL.country}. Para cualquier consulta puedes escribirnos a <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>

      <h2>2. Qué datos recogemos</h2>
      <h3>a) Datos que tú nos das</h3>
      <ul>
        <li><strong>Cuenta:</strong> nombre, email y foto de perfil (vía Google).</li>
        <li><strong>Pago:</strong> los datos de tarjeta los gestiona exclusivamente Stripe. Nosotros solo guardamos un identificador del cliente y el estado de tu suscripción.</li>
        <li><strong>Contenido del usuario:</strong> ofertas, análisis de cliente, propuestas y notas que generas dentro de la app.</li>
      </ul>
      <h3>b) Datos técnicos</h3>
      <ul>
        <li>Dirección IP, navegador, sistema operativo, idioma.</li>
        <li>Cookies estrictamente necesarias para mantener tu sesión iniciada.</li>
      </ul>

      <h2>3. Para qué los usamos</h2>
      <ul>
        <li>Crear tu cuenta y permitirte iniciar sesión de forma segura.</li>
        <li>Cobrar la suscripción mensual ({LEGAL.pricingMonthly}) o anual ({LEGAL.pricingYearly}) tras la prueba de {LEGAL.trialDays} días.</li>
        <li>Generar las ofertas, análisis y propuestas que solicitas usando inteligencia artificial.</li>
        <li>Mejorar el producto y prevenir fraude y abuso.</li>
        <li>Comunicarnos contigo sobre tu cuenta y novedades (solo lo esencial).</li>
      </ul>

      <h2>4. Inteligencia artificial</h2>
      <p>
        Para generar ofertas, análisis de clientes y propuestas usamos modelos de lenguaje de Anthropic (Claude). Los textos que escribes en los formularios se envían a sus servidores para producir el resultado. Anthropic no entrena modelos con tus datos cuando se accede vía API. No introduzcas información confidencial de terceros en los formularios.
      </p>

      <h2>5. Con quién compartimos tus datos</h2>
      <ul>
        <li><strong>Stripe</strong> (procesador de pagos, certificado PCI DSS Nivel 1).</li>
        <li><strong>Google</strong> (autenticación con tu cuenta Google).</li>
        <li><strong>Anthropic</strong> (modelo de IA que genera las respuestas).</li>
        <li><strong>MongoDB Atlas</strong> (base de datos donde guardamos tu cuenta y contenido).</li>
      </ul>
      <p>No vendemos ni cedemos tus datos a terceros con fines comerciales.</p>

      <h2>6. Cuánto tiempo conservamos tus datos</h2>
      <p>
        Mientras tengas la cuenta activa. Si cancelas la suscripción y pasan 12 meses sin actividad, eliminamos tus datos personales (excepto los registros fiscales obligatorios). Puedes pedir la eliminación inmediata en cualquier momento escribiendo a <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
      </p>

      <h2>7. Tus derechos</h2>
      <p>Tienes derecho a:</p>
      <ul>
        <li>Acceder a tus datos y obtener una copia.</li>
        <li>Rectificar datos incorrectos.</li>
        <li>Eliminar tu cuenta y todos tus datos.</li>
        <li>Limitar u oponerte al tratamiento.</li>
        <li>Portar tus datos a otro servicio.</li>
        <li>Retirar el consentimiento en cualquier momento.</li>
      </ul>
      <p>
        Para ejercerlos, escríbenos a <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>. Si crees que no respetamos tus derechos, puedes presentar una reclamación ante la autoridad de protección de datos de tu país (en Brasil, la ANPD; en la UE, la AEPD u homóloga).
      </p>

      <h2>8. Transferencias internacionales</h2>
      <p>
        Algunos de nuestros proveedores (Stripe, Google, Anthropic, MongoDB) procesan datos en Estados Unidos y la Unión Europea. Todos cumplen marcos de transferencia legales adecuados (cláusulas contractuales tipo, certificaciones de privacidad).
      </p>

      <h2>9. Cambios en esta política</h2>
      <p>
        Si modificamos esta política, te avisaremos por email al menos 15 días antes de que entren en vigor los cambios. La fecha en la cabecera siempre refleja la última versión vigente.
      </p>
    </LegalPage>
  );
}
